import styled from 'styled-components'

export const Center = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CenterContent = styled.div`
  min-height: 100vh;
  height: auto;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 30px;
`
